import axios, { AxiosError, AxiosInstance } from "axios";
import { AuthApi, Configuration, SearchApi, EntityUnitApi, PlatformApi, ProductTrackApi, ProfileApi, UserApi, BusinessMatchApi, BlobApi, SavedContactApi, SharingApi } from '@chainsight/networker-backend-axios-sdk';
import store from "@/store";
import userManager from "@/user-manager";

export const JWT_STORAGE_KEY = 'CHAINSIGHT_JWT';
export class Api {
    public authApi: AuthApi;
    public searchApi: SearchApi;
    public entityUnitApi: EntityUnitApi;
    public platformApi: PlatformApi;
    public productTrackApi: ProductTrackApi;
    public profileApi: ProfileApi;
    public userApi: UserApi;
    public businessMatchApi: BusinessMatchApi;
    public blobApi: BlobApi;
    public savedContactApi: SavedContactApi;
    public sharingApi: SharingApi;
    constructor(config: Configuration, baseUrl: string, axios: AxiosInstance) {
        this.authApi = new AuthApi(config, baseUrl, axios);
        this.searchApi = new SearchApi(config, baseUrl, axios);
        this.entityUnitApi = new EntityUnitApi(config, baseUrl, axios);
        this.platformApi = new PlatformApi(config, baseUrl, axios);
        this.productTrackApi = new ProductTrackApi(config, baseUrl, axios);
        this.profileApi = new ProfileApi(config, baseUrl, axios);
        this.userApi = new UserApi(config, baseUrl, axios);
        this.businessMatchApi = new BusinessMatchApi(config, baseUrl, axios);
        this.blobApi = new BlobApi(config, baseUrl, axios);
        this.savedContactApi = new SavedContactApi(config, baseUrl, axios);
        this.sharingApi = new SharingApi(config, baseUrl, axios);
    }
}

export const axiosInst = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 120000,
});
axiosInst.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, async (error: AxiosError) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.error(error);
    const authorization = error.config?.headers?.Authorization || error.config?.headers?.authorization;
    const failedToken = typeof authorization === 'string' ? /^Bearer\s+(\S+)$/i.exec(authorization)?.[1] : undefined;
    if (error.response?.status === 401 && failedToken) {
        const guestToken = localStorage.getItem('TMP_USER_EMAIL');
        if (guestToken) {
            if (guestToken === failedToken) localStorage.removeItem('TMP_USER_EMAIL');
        } else {
            const user = await userManager.getUser().catch(() => null);
            if (!localStorage.getItem('TMP_USER_EMAIL') && user?.access_token === failedToken) {
                userManager.signoutRedirect();
            }
        }
    }
    return Promise.reject(error);
});

const apiConfig = new Configuration({
    accessToken: async () => {
        const user = await userManager.getUser()
        if (user && !localStorage.getItem("TMP_USER_EMAIL")) {
            return user.access_token;
        } else if (localStorage.getItem("TMP_USER_EMAIL")) {
            return localStorage.getItem("TMP_USER_EMAIL") as string;
        }
        return '';
    }
})

export default new Api(apiConfig, process.env.VUE_APP_API_BASE_URL, axiosInst);
